module.exports = __webpack_public_path__ + "static/js/2.7c77774e.chunk.worker.js"